module.exports = __webpack_public_path__ + "img/bg_intro_3_2.b90be643.svg";